import { ReactElement } from 'react';
import classNames from 'classnames';
import { Header } from './Header';
import { Props } from './ProductVariantsMatrix.types';
import { Rows } from './Rows';
import './ProductVariantsMatrix.scss';

export const ProductVariantsMatrix = ({
  className,
  headerData,
  onStockCountClick,
  rowsData,
}: Props): ReactElement => {
  const rootClassName = classNames(
    'VariantsMatrixTable',
    'cds-Table',
    'cds-Table--Bordered',
    'cds-Table–-FullWidth',
    className,
  );

  return (
    <div className="Content–Scrollable">
      <table className={rootClassName}>
        <thead>
          <Header headerData={headerData} />
        </thead>
        <tbody>
          <Rows onStockCountClick={onStockCountClick} rowsData={rowsData} />
        </tbody>
      </table>
    </div>
  );
};
